import { render, staticRenderFns } from "./LeadsCustomersList.vue?vue&type=template&id=8c25d552&scoped=true"
import script from "./LeadsCustomersList.vue?vue&type=script&lang=js"
export * from "./LeadsCustomersList.vue?vue&type=script&lang=js"
import style0 from "./LeadsCustomersList.vue?vue&type=style&index=0&id=8c25d552&prod&lang=scss&scoped=true"
import style1 from "./LeadsCustomersList.vue?vue&type=style&index=1&id=8c25d552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c25d552",
  null
  
)

export default component.exports